import { Link } from "react-router-dom";
import { Sparkles, Instagram, Twitter, Youtube, Music2 } from "lucide-react";
import { getEffectiveRole } from "@/lib/site";
import { useAuth } from "@/lib/auth";

const COLS = [
  { title: "Platform", links: [
    ["How It Works", "/how-it-works"], ["For Creators", "/for-creators", "creator"],
    ["For Fans", "/for-fans", "fan"], ["Pricing", "/pricing", "creator"]] },
  { title: "Company", links: [
    ["About Us", "/about"], ["Careers", "/about"],
    ["Contact", "/contact"], ["Press", "/about"]] },
  { title: "Resources", links: [
    ["Help Center", "/how-it-works"], ["Creator Guide", "/for-creators", "creator"],
    ["Fan Guide", "/for-fans", "fan"], ["Terms of Service", "/about"]] },
];

export const Footer = () => {
  const { user } = useAuth();
  const role = getEffectiveRole(user);
  return (
  <footer className="border-t border-white/10 bg-[#0a0612]" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
      <div className="col-span-2 lg:col-span-2 pr-6">
        <Link to="/" className="flex items-center gap-2 mb-4">
          <div className="h-9 w-9 rounded-lg bg-brand grid place-items-center">
            <Sparkles size={18} className="text-white" />
          </div>
          <span className="font-display text-lg text-white">FAN <span className="text-brand">FOCUS</span></span>
        </Link>
        <p className="text-white/50 text-sm leading-relaxed max-w-xs">The Connection Platform for Creators and Fans.</p>
        <div className="flex items-center gap-4 mt-6">
          {[Instagram, Music2, Twitter, Youtube].map((I, i) => (
            <a key={i} href="#" className="text-white/50 hover:text-brand transition-colors"><I size={18} strokeWidth={1.6} /></a>
          ))}
        </div>
      </div>
      {COLS.map((c) => (
        <div key={c.title}>
          <div className="text-white/40 text-xs font-semibold uppercase tracking-widest mb-4">{c.title}</div>
          <ul className="space-y-3">
            {c.links.filter(([, , r]) => !r || r === role).map(([l, to]) => (
              <li key={l}><Link to={to} className="text-white/70 hover:text-white text-sm">{l}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-6 text-white/40 text-xs text-center">© {new Date().getFullYear()} Fan Focus. All rights reserved.</div>
    </div>
  </footer>
  );
};
